/* Nightframe Comics — interacciones del tema: carrito AJAX, aviso flotante,
   menú móvil y búsqueda/orden en vivo dentro del catálogo. */
(function () {
  "use strict";

  var routes = (window.NFRoutes || { cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cart: "/cart.js" });

  /* ---------- aviso flotante ---------- */
  var toastEl = document.getElementById("toast");
  var toastT = null;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.hidden = true; }, 2200);
  }
  window.NFToast = toast;

  function soles(n) {
    return "S/ " + Number(n).toFixed(2);
  }

  function whatsappOrderUrl(cart) {
    var message = ["Hola, quiero hacer este pedido en Nightframe Comics:", ""];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var variant = item.variant_title && item.variant_title !== "Default Title" ? " (" + item.variant_title + ")" : "";
      message.push("• " + item.quantity + " x " + item.product_title + variant + " — " + soles(item.final_line_price / 100));
    }
    message.push("", "Total: " + soles(cart.total_price / 100), "Entrega: coordinamos por WhatsApp el envío a domicilio o el pago contra entrega.");
    return "https://wa.me/51990223674?text=" + encodeURIComponent(message.join("\n"));
  }

  /* ---------- menú móvil ---------- */
  var navToggle = document.getElementById("navToggle");
  var mainNav = document.querySelector("nav.main");
  if (navToggle && mainNav) {
    navToggle.addEventListener("click", function () {
      var open = mainNav.getAttribute("data-open") === "1";
      mainNav.setAttribute("data-open", open ? "0" : "1");
      mainNav.style.display = open ? "" : "flex";
      navToggle.setAttribute("aria-expanded", open ? "false" : "true");
    });
  }

  /* ---------- carrito (drawer con AJAX Cart API) ---------- */
  var scrim = null, drawer = null;
  var cartCountEls = document.querySelectorAll("[data-cart-count]");

  function syncCount(count) {
    for (var i = 0; i < cartCountEls.length; i++) cartCountEls[i].textContent = count;
  }

  function fetchCart() {
    return fetch(routes.cart).then(function (r) { return r.json(); });
  }

  /* Conserva el punto exacto del catálogo al refrescar después de agregar. */
  var cartRefreshKey = "nightframe-cart-refresh";
  function rememberCartPosition(reopen) {
    try {
      sessionStorage.setItem(cartRefreshKey, JSON.stringify({
        x: Math.round(window.scrollX || 0),
        y: Math.round(window.scrollY || 0),
        reopen: !!reopen
      }));
    } catch (e) {}
  }
  function restoreCartPosition() {
    var raw = null, saved = null;
    try { raw = sessionStorage.getItem(cartRefreshKey); } catch (e) {}
    if (!raw) return;
    try { saved = JSON.parse(raw); } catch (e) {}
    try { sessionStorage.removeItem(cartRefreshKey); } catch (e) {}
    if (!saved) return;
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    var tries = 0;
    function restore() {
      window.scrollTo(saved.x || 0, saved.y || 0);
      tries++;
      if (tries < 12) setTimeout(restore, 120);
      else if (saved.reopen) openCart();
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", restore, { once: true });
    else restore();
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var lines = "";
    if (cart.items && cart.items.length) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, "_88x$1$2") + '" alt="" class="cover">'
          : '<span class="cover" data-nf-cover="' + it.id + '" data-nf-title="' + (it.product_title || "").replace(/"/g, "&quot;") + '" data-nf-small></span>';
        var safeTitle = esc(it.product_title || "Producto");
        lines +=
          '<div class="line">' + img +
          '<div><p class="t">' + it.product_title + '</p><p class="m">' + (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "") + '</p>' +
          '<div class="cart-line-actions"><div class="qty"><button type="button" data-qty-change="' + it.key + '" data-qty-delta="-1" aria-label="Disminuir cantidad">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-qty-change="' + it.key + '" data-qty-delta="1" aria-label="Aumentar cantidad">+</button></div><button type="button" class="remove-item" data-remove-item="' + it.key + '" aria-label="Eliminar ' + safeTitle + ' del carrito">Eliminar</button></div></div>' +
          '<span class="price">' + soles(it.final_line_price / 100) + '</span></div>';
      }
    } else {
      lines = '<div class="empty">Tu carrito está vacío. Empieza por las novedades del mes.</div>';
    }
    var sub = cart.total_price / 100;
    var whatsappUrl = whatsappOrderUrl(cart);
    drawer.innerHTML =
      '<header><h2>Tu carrito</h2><button class="xbtn" id="closeCart" aria-label="Cerrar carrito">✕</button></header>' +
      '<div class="lines">' + lines + "</div>" +
      "<footer>" +
      '<div class="row total"><span>Total</span><span class="mono">' + soles(sub) + "</span></div>" +
      '<p class="m" style="margin:0">Entrega: coordinamos por WhatsApp el envío o el pago contra entrega. No se suma aquí.</p>' +
      '<a class="btn" id="pay" target="_blank" rel="noopener" href="' + whatsappUrl + '"' + (cart.item_count ? "" : ' aria-disabled="true" style="pointer-events:none;opacity:.6"') + ">Pedir por WhatsApp</a>" +
      "</footer>";
    drawer.querySelector("#closeCart").addEventListener("click", closeCart);
    var qbtns = drawer.querySelectorAll("[data-qty-change]");
    for (var j = 0; j < qbtns.length; j++) {
      qbtns[j].addEventListener("click", function () {
        var key = this.getAttribute("data-qty-change");
        var delta = parseInt(this.getAttribute("data-qty-delta"), 10);
        var line = this.closest(".line");
        var span = line.querySelector(".qty span");
        var newQty = Math.max(0, parseInt(span.textContent, 10) + delta);
        changeQty(key, newQty);
      });
    }
    var removeBtns = drawer.querySelectorAll("[data-remove-item]");
    for (var k = 0; k < removeBtns.length; k++) {
      removeBtns[k].addEventListener("click", function () {
        changeQty(this.getAttribute("data-remove-item"), 0);
      });
    }
    if (window.NightframeCovers) window.NightframeCovers.fillPlaceholders(drawer);
  }

  function openCart(cartData) {
    if (drawer) {
      if (cartData) renderDrawer(cartData);
      return;
    }
    scrim = document.createElement("div");
    scrim.className = "scrim";
    scrim.addEventListener("click", closeCart);
    drawer = document.createElement("aside");
    drawer.className = "drawer";
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-label", "Carrito de compras");
    document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    document.addEventListener("keydown", onEsc);
    if (cartData) renderDrawer(cartData);
    else fetchCart().then(renderDrawer);
  }
  function onEsc(e) { if (e.key === "Escape") closeCart(); }
  function closeCart() {
    if (scrim) { scrim.remove(); scrim = null; }
    if (drawer) { drawer.remove(); drawer = null; }
    document.removeEventListener("keydown", onEsc);
  }

  function changeQty(key, quantity) {
    var controls = drawer ? drawer.querySelectorAll("[data-qty-change], [data-remove-item]") : [];
    for (var i = 0; i < controls.length; i++) controls[i].disabled = true;
    fetch(routes.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (e) {}
          if (!r.ok) throw new Error((data && data.description) || "No se pudo actualizar el carrito");
          return data && data.items ? data : fetchCart();
        });
      })
      .then(function (cart) {
        syncCount(cart.item_count);
        renderDrawer(cart);
        if (quantity === 0) toast("Producto eliminado del carrito");
      })
      .catch(function (err) {
        toast(err.message || "No se pudo actualizar el carrito");
        return fetchCart().then(function (cart) {
          syncCount(cart.item_count);
          renderDrawer(cart);
        });
      });
  }

  function addToCart(variantId, btn) {
    if (!variantId) { toast("Selecciona una opción antes de agregar"); return; }
    var qty = 1;
    if (btn) {
      var qtyInputId = btn.getAttribute("data-add-qty-input");
      if (qtyInputId) {
        var qtyInput = document.getElementById(qtyInputId);
        if (qtyInput) qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      }
    }
    if (btn) { btn.disabled = true; }
    fetch(routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (e) {}
          if (!r.ok) throw new Error((data && data.description) || "No se pudo agregar");
          return data || {};
        });
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        syncCount(cart.item_count);
        openCart(cart);
      })
      .catch(function (err) { toast(err.message || "No se pudo agregar al carrito"); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  document.addEventListener("click", function (ev) {
    var openBtn = ev.target.closest ? ev.target.closest("[data-open-cart]") : null;
    if (openBtn) { ev.preventDefault(); openCart(); return; }
    var addBtn = ev.target.closest ? ev.target.closest("[data-add-to-cart]") : null;
    if (addBtn) {
      ev.preventDefault();
      addToCart(addBtn.getAttribute("data-add-to-cart"), addBtn);
      return;
    }
    var plan = ev.target.closest ? ev.target.closest("[data-plan]") : null;
    if (plan) { ev.preventDefault(); toast("Plan " + plan.getAttribute("data-plan") + " · te escribiremos para confirmar"); }
  });

  fetchCart().then(function (cart) { syncCount(cart.item_count); }).catch(function () {});
  restoreCartPosition();

  /* ---------- catálogo: filtros, orden, "Cargar más" y búsqueda en vivo ----------
     Cada filtro pide la lista de productos de su colección en formato JSON
     (/collections/<colección>/products.json). Eso no depende del tema que se esté
     viendo, así que funciona igual en la vista previa y en la tienda publicada.
     Todo se busca en el momento para que siga funcionando si el editor redibuja la sección. */
  var catalogCache = {};
  var catalogState = null;

  function catalogParts(from) {
    var catalog = from && from.closest ? from.closest("[data-catalog]") : null;
    if (!catalog) catalog = document.querySelector("[data-catalog]");
    if (!catalog) return null;
    return {
      catalog: catalog,
      grid: catalog.querySelector("#grid"),
      count: catalog.querySelector("#countLine"),
      moreWrap: catalog.querySelector("#loadMoreWrap"),
      sort: catalog.querySelector("#orden"),
      search: catalog.querySelector("[data-catalog-search]")
    };
  }

  /* Actualiza el contador "X de Y títulos". */
  function applyLiveFilter() {
    var p = catalogParts();
    if (!p || !p.grid || !p.count) return;
    var cards = p.grid.querySelectorAll("[data-card]").length;
    var total = parseInt(p.count.getAttribute("data-total"), 10);
    if (isNaN(total)) total = cards;
    p.count.textContent = cards + " de " + total + " títulos";
  }
  applyLiveFilter();

  /* ---------- búsqueda dentro del catálogo ---------- */
  function normalize(str) {
    var t = String(str || "").toLowerCase();
    if (t.normalize) t = t.normalize("NFD").replace(/[̀-ͯ]/g, "");
    return t.replace(/[^a-z0-9ñ]+/g, " ").trim();
  }

  function productWords(prod) {
    if (!prod._nfWords) {
      var tags = Array.isArray(prod.tags) ? prod.tags.join(" ") : String(prod.tags || "");
      prod._nfWords = normalize([prod.title, prod.vendor, prod.product_type, tags].join(" ")).split(" ");
    }
    return prod._nfWords;
  }

  function matchesQuery(prod, tokens) {
    var words = productWords(prod);
    for (var t = 0; t < tokens.length; t++) {
      var ok = false;
      for (var w = 0; w < words.length; w++) if (words[w].indexOf(tokens[t]) === 0) { ok = true; break; }
      if (!ok) return false;
    }
    return true;
  }

  function currentQuery(p) {
    return p && p.search ? p.search.value.trim() : "";
  }

  function filterByQuery(list, query) {
    var tokens = normalize(query).split(" ").filter(Boolean);
    if (!tokens.length) return list;
    return list.filter(function (prod) { return matchesQuery(prod, tokens); });
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function formatMoney(amount, fmt) {
    var n = Number(amount) || 0;
    function group(num, dec, thou, decSep) {
      var parts = num.toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + decSep + parts[1] : parts[0];
    }
    fmt = fmt || "S/ {{amount}}";
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case "amount_no_decimals": return group(n, 0, ",", ".");
        case "amount_with_comma_separator": return group(n, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(n, 0, ".", ",");
        case "amount_with_apostrophe_separator": return group(n, 2, "'", ".");
        default: return group(n, 2, ",", ".");
      }
    });
  }

  function productCardHtml(prod, opts) {
    var variants = prod.variants || [];
    var cheapest = variants[0] || {};
    for (var i = 1; i < variants.length; i++) if (Number(variants[i].price) < Number(cheapest.price)) cheapest = variants[i];
    var buyVariant = null;
    for (var j = 0; j < variants.length; j++) if (variants[j].available) { buyVariant = variants[j]; break; }
    var available = !!buyVariant;
    buyVariant = buyVariant || variants[0] || {};
    var price = Number(cheapest.price || 0);
    var compare = Number(cheapest.compare_at_price || 0);
    var tags = Array.isArray(prod.tags) ? prod.tags : String(prod.tags || "").split(/\s*,\s*/).filter(Boolean);
    var url = "/products/" + prod.handle;
    var img = prod.images && prod.images[0] ? (prod.images[0].src || prod.images[0]) : null;
    if (img) img += (img.indexOf("?") === -1 ? "?" : "&") + "width=600";
    var lower = tags.map(function (t) { return String(t).toLowerCase(); });
    var badge = "";
    if (lower.indexOf("firmado") !== -1) badge = '<span class="badge firmado">Firmado</span>';
    else if (lower.indexOf("preventa") !== -1) badge = '<span class="badge preventa">Preventa</span>';
    else if (compare > price) badge = '<span class="badge oferta">Oferta</span>';
    else if (lower.indexOf("nuevo") !== -1) badge = '<span class="badge nuevo">Nuevo</span>';
    var haystack = [prod.title, prod.vendor, prod.product_type].concat(tags).join(" ");
    var edit = opts.adminBase
      ? '<a class="card-edit" href="' + esc(opts.adminBase) + "/products/" + prod.id + '" target="_blank" rel="noopener" title="Editar en Shopify" onclick="event.stopPropagation()">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"></path></svg>' +
        '<span class="visually-hidden">Editar producto</span></a>'
      : "";
    return '<article class="card" data-card data-search="' + esc(haystack) + '">' + edit +
      '<a href="' + esc(url) + '" class="covwrap" style="display:block">' +
        (img
          ? '<img class="cover" src="' + esc(img) + '" width="300" height="450" loading="lazy" alt="' + esc(prod.title) + '">'
          : '<span class="cover" style="display:block" data-nf-cover="' + prod.id + '" data-nf-title="' + esc(prod.title) + '"></span>') +
        badge +
      "</a>" +
      '<div class="body">' +
        '<p class="serie">' + esc(prod.vendor) + (prod.product_type ? " · " + esc(prod.product_type) : "") + "</p>" +
        '<h3><a href="' + esc(url) + '">' + esc(prod.title) + "</a></h3>" +
        (tags.length ? '<p class="specs">' + esc(tags.join(" · ")) + "</p>" : "") +
        '<div class="foot"><span class="price">' +
          (compare > price ? "<s>" + esc(formatMoney(compare, opts.moneyFormat)) + "</s> " : "") +
          esc(formatMoney(price, opts.moneyFormat)) +
        "</span>" +
        (available
          ? '<button type="button" class="add" data-add-to-cart="' + buyVariant.id + '">Agregar</button>'
          : '<button type="button" class="add" disabled>Agotado</button>') +
        "</div>" +
      "</div>" +
    "</article>";
  }

  function sortProducts(list, key) {
    var arr = list.slice();
    function minPrice(p) {
      var v = p.variants || [], m = Infinity;
      for (var i = 0; i < v.length; i++) m = Math.min(m, Number(v[i].price));
      return m === Infinity ? 0 : m;
    }
    function titleParts(product) {
      var title = String(product.title || "").trim();
      var match = title.match(/^(.*?)(?:\s*#\s*(\d+(?:\.\d+)?))\b(.*)$/);
      if (!match) return { series: title, issue: Number.MAX_SAFE_INTEGER, rest: "" };
      return { series: match[1].trim(), issue: Number(match[2]), rest: match[3].trim() };
    }
    function coverRank(rest) {
      var text = normalize(rest);
      if (!text || text.indexOf("main cover") !== -1) return 0;
      var coverAt = text.indexOf("cover ");
      if (coverAt !== -1) {
        var letter = text.charAt(coverAt + 6);
        if (letter === "a") return 0;
        if (letter >= "b" && letter <= "z") return letter.charCodeAt(0) - 96;
      }
      if (text.indexOf("variant") !== -1) return 100;
      return 0;
    }
    var byCatalog = function (a, b) {
      var pa = titleParts(a), pb = titleParts(b);
      var series = pa.series.localeCompare(pb.series, "es", { numeric: true, sensitivity: "base" });
      if (series) return series;
      if (pa.issue !== pb.issue) return pa.issue - pb.issue;
      var rank = coverRank(pa.rest) - coverRank(pb.rest);
      if (rank) return rank;
      return pa.rest.localeCompare(pb.rest, "es", { numeric: true, sensitivity: "base" });
    };
    switch (key) {
      case "price-ascending": arr.sort(function (a, b) { return minPrice(a) - minPrice(b) || byCatalog(a, b); }); break;
      case "price-descending": arr.sort(function (a, b) { return minPrice(b) - minPrice(a) || byCatalog(a, b); }); break;
      case "created-descending": arr.sort(function (a, b) { return new Date(b.created_at || b.published_at) - new Date(a.created_at || a.published_at) || byCatalog(a, b); }); break;
      case "title-descending": arr.sort(function (a, b) { return byCatalog(b, a); }); break;
      case "catalog-order":
      case "title-ascending":
      default: arr.sort(byCatalog);
    }    return arr;
  }

  function collectionPath(href) {
    var u = new URL(href, window.location.origin);
    var path = u.pathname.replace(/\/+$/, "");
    if (!/^\/collections\/[^/]+$/.test(path)) path = "/collections/all";
    return path;
  }

  function fetchCollection(path) {
    if (catalogCache[path]) return Promise.resolve(catalogCache[path]);
    var all = [];
    function page(n) {
      return fetch(path + "/products.json?limit=250&page=" + n, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var items = (data && data.products) || [];
          all = all.concat(items);
          if (items.length === 250 && n < 20) return page(n + 1);
          catalogCache[path] = all;
          return all;
        });
    }
    return page(1);
  }

  /* fromIndex: desde qué portada empieza la animación de entrada (0 = todas). */
  function renderCatalog(p, fromIndex) {
    var st = catalogState;
    var list = st.sorted.slice(0, st.shown);
    var from = fromIndex || 0;
    var opts = {
      moneyFormat: p.catalog.getAttribute("data-money-format"),
      adminBase: p.catalog.getAttribute("data-admin-base")
    };
    var html = "";
    for (var i = 0; i < list.length; i++) {
      var card = productCardHtml(list[i], opts);
      if (i >= from) card = card.replace('<article class="card"', '<article class="card card--in" style="--i:' + Math.min(i - from, 12) + '"');
      html += card;
    }
    if (html) {
      p.grid.innerHTML = html;
    } else if (st.all && st.all.length && st.query) {
      p.grid.innerHTML = comingSoonHtml(st.query, {
        mini: true,
        title: "¡Ups!",
        caption: "Búsqueda",
        text: "No encontramos «" + st.query + "». ¡Prueba con otro título!",
        cta: "Borrar búsqueda",
        ctaAttr: "data-search-clear"
      });
      startComingSoon(p.grid);
    } else {
      p.grid.innerHTML = comingSoonHtml(st.label);
      startComingSoon(p.grid);
    }
    if (p.count) p.count.setAttribute("data-total", String(st.sorted.length));
    if (p.moreWrap) {
      p.moreWrap.innerHTML = st.shown < st.sorted.length
        ? '<a class="btn loadmore" id="loadMore" href="' + esc(st.path) + '">Cargar más</a>'
        : "";
    }
    if (window.NightframeCovers) window.NightframeCovers.fillPlaceholders(p.grid);
    applyLiveFilter();
    if (p.count) {
      p.count.classList.remove("bump");
      void p.count.offsetWidth;
      p.count.classList.add("bump");
    }
  }

  /* ---------- "¡Próximamente!": panel de historieta para colecciones vacías ---------- */
  var SOON_WORDS = ["¡POW!", "¡BAM!", "¡ZAS!", "¡KRAK!", "¡BOOM!", "¡WHAM!", "¡ZOOM!", "¡KAPOW!", "¡SNIKT!", "¡THWIP!"];
  var reduceMotion = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  function starPoints(spikes, cx, cy, rx, ry, inner) {
    var pts = [];
    for (var i = 0; i < spikes * 2; i++) {
      var ang = (Math.PI * i) / spikes - Math.PI / 2;
      var k = i % 2 ? inner : (i % 4 === 0 ? 1 : 0.9);
      pts.push((cx + Math.cos(ang) * rx * k).toFixed(1) + "," + (cy + Math.sin(ang) * ry * k).toFixed(1));
    }
    return pts.join(" ");
  }

  function comingSoonHtml(label, opts) {
    opts = opts || {};
    var name = String(label || "Esta sección").trim();
    var text = opts.text || (name + ": ¡muy pronto en Nightframe!");
    var title = opts.title ? esc(opts.title) : "¡Próxima&shy;mente!";
    var aria = opts.title ? opts.title + " " + text : "Próximamente: " + name;
    return '<div class="nf-soon' + (opts.mini ? " nf-soon--mini" : "") + '" data-soon role="region" aria-label="' + esc(aria) + '">' +
      '<div class="nf-soon__rays" aria-hidden="true"></div><div class="nf-soon__dots" aria-hidden="true"></div>' +
      '<p class="nf-soon__caption">' + esc(opts.caption || "Mientras tanto, en Nightframe…") + "</p>" +
      '<span class="nf-soon__fx nf-soon__fx--a" aria-hidden="true">¡POW!</span>' +
      '<span class="nf-soon__fx nf-soon__fx--b" aria-hidden="true">¡ZAS!</span>' +
      '<span class="nf-soon__fx nf-soon__fx--c" aria-hidden="true">¡BAM!</span>' +
      '<div class="nf-soon__stage">' +
        '<button type="button" class="nf-soon__burst" data-soon-burst aria-label="' + esc(opts.title || "¡Próximamente!") + '">' +
          '<svg viewBox="0 0 520 400" aria-hidden="true">' +
            '<polygon class="b-out" points="' + starPoints(18, 260, 200, 255, 195, 0.7) + '"/>' +
            '<polygon class="b-in" points="' + starPoints(18, 260, 200, 200, 148, 0.82) + '"/>' +
          "</svg>" +
          '<span class="nf-soon__title">' + title + "</span>" +
        "</button>" +
        '<p class="nf-soon__bubble"><span data-soon-type data-text="' + esc(text) + '">' + (reduceMotion ? esc(text) : "") + '</span><span class="nf-soon__caret" aria-hidden="true"></span></p>' +
        '<p class="nf-soon__hint" data-soon-hint>Toca la explosión</p>' +
        '<button type="button" class="btn nf-soon__cta" ' + (opts.ctaAttr || "data-path-reset") + ">" + esc(opts.cta || "Explorar el catálogo") + "</button>" +
      "</div>" +
    "</div>";
  }

  function startComingSoon(root) {
    var nodes = (root || document).querySelectorAll("[data-soon-type]");
    for (var i = 0; i < nodes.length; i++) typeText(nodes[i]);
  }

  function typeText(el) {
    var full = el.getAttribute("data-text") || "";
    if (reduceMotion || el.getAttribute("data-typed")) { el.textContent = full; return; }
    el.setAttribute("data-typed", "1");
    var n = 0;
    setTimeout(function tick() {
      if (!el.isConnected) return;
      n++;
      el.textContent = full.slice(0, n);
      if (n < full.length) setTimeout(tick, full.charAt(n - 1) === ":" ? 220 : 38);
    }, 650);
  }

  function initComingSoonSlots(root) {
    var slots = (root || document).querySelectorAll("[data-coming-soon]");
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      var catalog = slot.closest("[data-catalog]");
      var label = slot.getAttribute("data-label");
      if (catalog) {
        var sel = selectionLabel(catalog);
        if (sel) label = sel;
      }
      slot.outerHTML = comingSoonHtml(label);
    }
    startComingSoon(root);
  }

  var soonCombo = 0, soonTimer = null;
  document.addEventListener("click", function (ev) {
    if (!ev.target.closest) return;
    var burst = ev.target.closest("[data-soon-burst]");
    if (!burst) return;
    var panel = burst.closest("[data-soon]");
    burst.classList.remove("is-boom");
    void burst.offsetWidth;
    burst.classList.add("is-boom");
    var rect = panel.getBoundingClientRect();
    var x = (ev.clientX || rect.left + rect.width / 2) - rect.left;
    var y = (ev.clientY || rect.top + rect.height / 2) - rect.top;
    var pop = document.createElement("span");
    pop.className = "nf-soon__pop";
    pop.setAttribute("aria-hidden", "true");
    pop.textContent = SOON_WORDS[Math.floor(Math.random() * SOON_WORDS.length)];
    pop.style.left = Math.max(10, Math.min(rect.width - 140, x - 50)) + "px";
    pop.style.top = Math.max(10, y - 30) + "px";
    pop.style.setProperty("--r", (Math.random() * 30 - 15).toFixed(0) + "deg");
    panel.appendChild(pop);
    setTimeout(function () { if (pop.parentNode) pop.parentNode.removeChild(pop); }, 950);
    soonCombo++;
    clearTimeout(soonTimer);
    soonTimer = setTimeout(function () { soonCombo = 0; }, 1400);
    var hint = panel.querySelector("[data-soon-hint]");
    if (hint && soonCombo >= 3) {
      hint.textContent = "¡Combo x" + soonCombo + "!";
      hint.classList.remove("is-combo");
      void hint.offsetWidth;
      hint.classList.add("is-combo");
    }
  });

  document.addEventListener("animationend", function (ev) {
    if (ev.target.classList && ev.target.classList.contains("is-boom")) ev.target.classList.remove("is-boom");
  });

  document.addEventListener("pointermove", function (ev) {
    if (reduceMotion || ev.pointerType === "touch" || !ev.target.closest) return;
    var panel = ev.target.closest("[data-soon]");
    if (!panel) return;
    var r = panel.getBoundingClientRect();
    panel.style.setProperty("--mx", (((ev.clientX - r.left) / r.width) * 2 - 1).toFixed(3));
    panel.style.setProperty("--my", (((ev.clientY - r.top) / r.height) * 2 - 1).toFixed(3));
  });

  function selectionLabel(catalog) {
    var fmt = catalog.querySelector('[data-chip][data-row="tipo"].is-active');
    if (fmt && !fmt.getAttribute("data-handle")) fmt = null;
    var scope = catalog.querySelector('[data-chip][data-row="saga"].is-active') || catalog.querySelector('[data-chip][data-row="editorial"].is-active');
    var a = fmt ? fmt.getAttribute("data-label") : "";
    var b = scope ? scope.getAttribute("data-label") : "";
    if (a && b) return a + " de " + b;
    return a || b || "";
  }

  /* ---------- selección actual: formato (fila 1) + editorial o saga (filas 2 y 3) ----------
     Los dos se combinan: "Marvel" + "Tomos" muestra solo los tomos de Marvel. */
  function activeIn(catalog, row) {
    return catalog.querySelector('[data-chip][data-row="' + row + '"].is-active');
  }

  function selection(p) {
    var c = p.catalog;
    var fmt = activeIn(c, "tipo");
    if (fmt && !fmt.getAttribute("data-handle")) fmt = null;
    var scope = activeIn(c, "saga") || activeIn(c, "editorial");
    var series = scope ? (scope.getAttribute("data-series") || "") : "";
    var fmtPath = fmt ? collectionPath(fmt.getAttribute("href")) : "";
    var scopePath = scope ? collectionPath(scope.getAttribute("href")) : "";
    if (series) scopePath = "/collections/all";
    if (!fmtPath && !scopePath) scopePath = "/collections/all";
    return { fmt: fmt, scope: scope, series: series, fmtPath: fmtPath, scopePath: scopePath, key: scopePath + "|" + fmtPath + "|" + series };
  }

  function isDraftPreventaPath(path) {
    return path === "/collections/preventa";
  }

  function tagsOf(product) {
    return Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",");
  }

  function canonicalSeriesName(name) {
    var clean = String(name || "").trim();
    if (normalize(clean) === "clayface celebrity dirt") return "Clayface";
    return clean;
  }

  function seriesOf(product) {
    var tags = tagsOf(product);
    for (var i = 0; i < tags.length; i++) {
      var match = String(tags[i]).trim().match(/^serie:\s*(.+)$/i);
      if (match) return canonicalSeriesName(match[1]);
    }
    return "";
  }

  function productHasSeries(product, name) {
    var wanted = normalize(canonicalSeriesName(name));
    var tags = tagsOf(product);
    for (var i = 0; i < tags.length; i++) {
      var raw = String(tags[i]).trim();
      if (normalize(canonicalSeriesName(raw)) === wanted) return true;
      var match = raw.match(/^serie:\s*(.+)$/i);
      if (match && normalize(canonicalSeriesName(match[1])) === wanted) return true;
    }
    return false;
  }

  function filterDraftPreventa(list) {
    var today = new Date();
    var y = today.getFullYear();
    var m = String(today.getMonth() + 1).padStart(2, "0");
    var d = String(today.getDate()).padStart(2, "0");
    var todayKey = y + "-" + m + "-" + d;
    return (list || []).filter(function (product) {
      var tags = tagsOf(product), fallback = false;
      for (var i = 0; i < tags.length; i++) {
        var tag = String(tags[i]).trim();
        var dateMatch = tag.match(/^fecha:\s*(\d{4}-\d{2}-\d{2})$/i);
        if (dateMatch) return dateMatch[1] > todayKey;
        var lower = tag.toLowerCase();
        if (lower === "preventa" || lower === "midnight spider-man" || lower === "midnight x-men" || lower === "midnight fantastic four") fallback = true;
      }
      return fallback;
    });
  }


  function releaseDateOf(product) {
    var tags = tagsOf(product);
    for (var i = 0; i < tags.length; i++) {
      var match = String(tags[i]).trim().match(/^fecha:\s*(\d{4}-\d{2}-\d{2})$/i);
      if (match) return match[1];
    }
    return "";
  }

  function productAvailable(product) {
    var variants = product && product.variants || [];
    for (var i = 0; i < variants.length; i++) if (variants[i].available) return true;
    return false;
  }

  function productIsVariant(product) {
    var title = normalize(product && product.title);
    var tags = normalize(tagsOf(product).join(" "));
    if (tags.indexOf("portada principal") !== -1) return false;
    return /(?:variant|variante|blank cover|foil|cvr [b-z]|cover [b-z])/.test(title + " " + tags);
  }

  function productIsMainCover(product) {
    var title = normalize(product && product.title);
    var tags = normalize(tagsOf(product).join(" "));
    return tags.indexOf("portada principal") !== -1 || /(?:main cover|cvr a|cover a)/.test(title) || !productIsVariant(product);
  }

  function smartViewLabel(view) {
    var labels = {
      preorder: "Preventas",
      arrived: "Recién llegados",
      main: "Portadas principales",
      variants: "Variantes",
      "month-2026-10": "Salidas de octubre 2026",
      "month-2026-11": "Salidas de noviembre 2026",
      "month-2026-12": "Salidas de diciembre 2026"
    };
    return labels[view] || "Catálogo";
  }

  function syncSmartView(catalog, view) {
    if (!catalog) return;
    var buttons = catalog.querySelectorAll("[data-nf-view]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-nf-view") === view;
      buttons[i].classList.toggle("is-active", active);
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
    }
  }

  function applySmartView(p, view, sortKey, shownTarget) {
    if (!p || !p.grid) return;
    var pageSize = parseInt(p.catalog.getAttribute("data-page-size"), 10) || 12;
    var excludeId = p.catalog.getAttribute("data-exclude-id");
    p.catalog.classList.add("is-loading");
    var selected = selection(p);
    var sourcePromise = (selected.scope || selected.series || selected.fmt) ? fetchSelection(selected) : fetchCollection("/collections/all");
    sourcePromise.then(function (products) {
      var now = new Date();
      var todayKey = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");
      var list = (products || []).filter(function (product) {
        var date = releaseDateOf(product);
        var tags = normalize(tagsOf(product).join(" "));
        if (view === "preorder") return filterDraftPreventa([product]).length > 0;
        if (view === "arrived") return productAvailable(product) && !tagsOf(product).some(function (t) { return normalize(t) === "llegando"; }) && (date ? date <= todayKey : tags.indexOf("preventa") === -1);
        if (view === "main") return productIsMainCover(product);
        if (view === "variants") return productIsVariant(product);
        if (view.indexOf("month-") === 0) return date.indexOf(view.slice(6)) === 0;
        return true;
      });
      if (excludeId) list = list.filter(function (x) { return String(x.id) !== excludeId; });
      var all = sortProducts(list, sortKey || "catalog-order");
      var query = currentQuery(p);
      catalogState = {
        key: "view:" + view + "|" + selected.key,
        view: view,
        path: (selected.scopePath || "/collections/all") + "?nf_view=" + encodeURIComponent(view) + "#catalogo",
        combo: !!selected.scope,
        label: (selectionLabel(p.catalog) ? selectionLabel(p.catalog) + " · " : "") + smartViewLabel(view),
        sort: sortKey || "catalog-order",
        all: all,
        query: query,
        sorted: filterByQuery(all, query),
        shown: Math.max(pageSize, shownTarget || 0)
      };
      syncSmartView(p.catalog, view);
      renderCatalog(p);
    }).catch(function () {
      window.location.href = "/collections/all?nf_view=" + encodeURIComponent(view) + "#catalogo";
    }).then(function () { p.catalog.classList.remove("is-loading"); });
  }

  function fetchSelection(sel) {
    var scopeIsPreventa = isDraftPreventaPath(sel.scopePath);
    var fmtIsPreventa = isDraftPreventaPath(sel.fmtPath);
    var scopePath = scopeIsPreventa ? "/collections/all" : sel.scopePath;
    var fmtPath = fmtIsPreventa ? "/collections/all" : sel.fmtPath;
    var a = scopePath ? fetchCollection(scopePath) : Promise.resolve(null);
    var b = fmtPath ? fetchCollection(fmtPath) : Promise.resolve(null);
    return Promise.all([a, b]).then(function (r) {
      var result;
      if (r[0] && r[1]) {
        var ids = {};
        for (var i = 0; i < r[1].length; i++) ids[r[1][i].id] = true;
        result = r[0].filter(function (x) { return ids[x.id]; });
      } else {
        result = r[0] || r[1] || [];
      }
      if (sel.series) {
        var wanted = normalize(sel.series);
        result = result.filter(function (product) { return productHasSeries(product, wanted); });
      }
      return (scopeIsPreventa || fmtIsPreventa) ? filterDraftPreventa(result) : result;
    });
  }

  /* shownTarget: cuántas portadas mostrar (si no se indica, una tanda). */
  function showSelection(p, sortKey, shownTarget) {
    if (!p || !p.grid) return;
    var sel = selection(p);
    var pageSize = parseInt(p.catalog.getAttribute("data-page-size"), 10) || 12;
    var excludeId = p.catalog.getAttribute("data-exclude-id");
    p.catalog.classList.add("is-loading");
    fetchSelection(sel)
      .then(function (products) {
        ensureSeriesChips(p.catalog, products);
        if (selection(p).key !== sel.key) return;
        var list = excludeId ? products.filter(function (x) { return String(x.id) !== excludeId; }) : products;
        var all = sortProducts(list, sortKey);
        var query = currentQuery(p);
        catalogState = {
          key: sel.key,
          path: sel.scopePath || sel.fmtPath,
          combo: !!(sel.scopePath && sel.fmtPath),
          label: selectionLabel(p.catalog),
          sort: sortKey,
          all: all,
          query: query,
          sorted: filterByQuery(all, query),
          shown: Math.max(pageSize, shownTarget || 0)
        };
        renderCatalog(p);
      })
      .catch(function () {
        var to = sel.scopePath || sel.fmtPath;
        window.location.href = to + (sortKey ? "?sort_by=" + encodeURIComponent(sortKey) : "");
      })
      .then(function () { p.catalog.classList.remove("is-loading"); });
  }

  function visibleCards(p) {
    return p.grid ? p.grid.querySelectorAll("[data-card]").length : 0;
  }

  function ensureSeriesChips(catalog, products) {
    var stage = catalog && catalog.querySelector("[data-saga-row] .saga-stage");
    if (!stage || stage.getAttribute("data-series-ready")) return;
    var existing = {};
    var chips = stage.querySelectorAll('[data-chip][data-row="saga"]');
    for (var i = 0; i < chips.length; i++) existing[normalize(chips[i].getAttribute("data-label"))] = chips[i];
    Object.keys(existing).forEach(function (key) {
      var chip = existing[key];
      var label = chip.getAttribute("data-label") || "";
      var count = (products || []).filter(function (product) { return productHasSeries(product, label); }).length;
      if (!count) return;
      chip.setAttribute("data-series", label);
      chip.href = "/collections/all";
      var badge = chip.querySelector(".chip-count");
      if (badge) badge.textContent = count;
    });
    var found = {};
    (products || []).forEach(function (product) {
      var name = seriesOf(product);
      if (!name) return;
      var key = normalize(name);
      if (!found[key]) found[key] = { name: name, count: 0, parent: normalize(product.vendor).indexOf("marvel") !== -1 ? "marvel-comics" : "dc-comics" };
    });
    Object.keys(found).forEach(function (key) {
      found[key].count = (products || []).filter(function (product) { return productHasSeries(product, found[key].name); }).length;
    });
    Object.keys(found).sort(function (a, b) { return found[a].name.localeCompare(found[b].name, "es", { numeric: true, sensitivity: "base" }); }).forEach(function (key) {
      var item = found[key];
      var chip = existing[key];
      if (chip) {
        chip.setAttribute("data-series", item.name);
        chip.setAttribute("data-parent", item.parent);
        chip.href = "/collections/all";
        var count = chip.querySelector(".chip-count");
        if (count) count.textContent = item.count;
        return;
      }
      chip = document.createElement("a");
      chip.className = "chip chip--sm";
      chip.setAttribute("data-chip", "");
      chip.setAttribute("data-row", "saga");
      chip.setAttribute("data-handle", "serie-" + key.replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""));
      chip.setAttribute("data-series", item.name);
      chip.setAttribute("data-label", item.name);
      chip.setAttribute("data-parent", item.parent);
      chip.setAttribute("aria-pressed", "false");
      chip.href = "/collections/all";
      chip.innerHTML = '<span class="chip-label">' + esc(item.name) + '</span><span class="chip-count">' + item.count + '</span>';
      stage.appendChild(chip);
    });
    stage.setAttribute("data-series-ready", "1");
    syncSteps(catalog, false);
  }

  /* ---------- pasos: 1) editorial → 2) sagas de esa editorial ---------- */
  function chipsIn(catalog, row) {
    return catalog.querySelectorAll('[data-chip][data-row="' + row + '"]');
  }

  function setActive(chip, on) {
    chip.classList.toggle("is-active", on);
    chip.setAttribute("aria-pressed", on ? "true" : "false");
  }

  function clearRow(catalog, row) {
    var list = chipsIn(catalog, row);
    for (var i = 0; i < list.length; i++) setActive(list[i], false);
  }

  function allFormatsChip(catalog) {
    var tipos = chipsIn(catalog, "tipo");
    for (var i = 0; i < tipos.length; i++) if (!tipos[i].getAttribute("data-handle")) return tipos[i];
    return null;
  }

  function syncSteps(catalog, animate) {
    if (!catalog) return;
    if (!activeIn(catalog, "tipo")) {
      var allChip = allFormatsChip(catalog);
      if (allChip) setActive(allChip, true);
    }
    var active = activeIn(catalog, "saga") || activeIn(catalog, "editorial");
    var editorials = chipsIn(catalog, "editorial");
    var sagas = chipsIn(catalog, "saga");
    var parentHandle = "";
    var activeRow = active ? active.getAttribute("data-row") : "";
    if (activeRow === "editorial") parentHandle = active.getAttribute("data-handle") || "";
    else if (activeRow === "saga") parentHandle = active.getAttribute("data-parent") || "";

    var parentChip = null;
    for (var i = 0; i < editorials.length; i++) {
      var isParent = !!parentHandle && editorials[i].getAttribute("data-handle") === parentHandle;
      if (isParent) parentChip = editorials[i];
      editorials[i].classList.toggle("is-parent", isParent && activeRow === "saga");
    }

    var noEditorials = editorials.length === 0;
    var shownCount = 0, delay = 0;
    for (var j = 0; j < sagas.length; j++) {
      var chip = sagas[j];
      var parent = chip.getAttribute("data-parent") || "";
      var show = noEditorials || (!!parentHandle && parent === parentHandle) || chip.classList.contains("is-active");
      var wasShown = chip.classList.contains("is-shown");
      chip.classList.toggle("is-shown", show);
      if (show) {
        shownCount++;
        if (animate && !wasShown) {
          chip.classList.remove("is-entering");
          void chip.offsetWidth;
          chip.style.animationDelay = (delay++ * 45) + "ms";
          chip.classList.add("is-entering");
        }
      } else {
        chip.classList.remove("is-entering");
      }
    }

    var row = catalog.querySelector("[data-saga-row]");
    if (row) row.classList.toggle("is-open", shownCount > 0);
    var editorialRow = catalog.querySelector(".filter-row--editorial");
    if (editorialRow) editorialRow.classList.toggle("is-done", !!parentHandle);
    var hint = catalog.querySelector("[data-saga-hint]");
    if (hint && hint.lastChild) {
      if (!hint.hasAttribute("data-default")) hint.setAttribute("data-default", hint.lastChild.textContent);
      hint.hidden = shownCount > 0;
      hint.lastChild.textContent = parentHandle && shownCount === 0
        ? " Esta editorial todavía no tiene sagas"
        : hint.getAttribute("data-default");
    }

    var fmt = activeIn(catalog, "tipo");
    if (fmt && !fmt.getAttribute("data-handle")) fmt = null;
    renderPath(catalog, active, activeRow, parentChip, fmt);
  }

  function renderPath(catalog, active, activeRow, parentChip, fmt) {
    var box = catalog.querySelector("[data-filter-path]");
    if (!box) return;
    var lead = '<span class="filter-path__lead">Mostrando</span>';
    var searchBox = catalog.querySelector("[data-catalog-search]");
    var q = searchBox ? searchBox.value.trim() : "";
    var qCrumb = q ? '<button type="button" class="filter-path__crumb filter-path__crumb--fmt filter-path__crumb--q is-current" data-search-clear title="Borrar búsqueda">“' + esc(q) + "”</button>" : "";
    if (!active && !fmt && q) {
      box.innerHTML = lead + '<span class="filter-path__crumb">Todo</span><span class="filter-path__sep" aria-hidden="true">·</span>' + qCrumb +
        '<button type="button" class="filter-path__reset" data-path-reset aria-label="Quitar filtros">✕ Ver todo</button>';
      box.classList.add("has-filter");
      return;
    }
    if (!active && !fmt) {
      box.innerHTML = lead + '<span class="filter-path__crumb is-current">Todo el catálogo</span>';
      box.classList.remove("has-filter");
      return;
    }
    var parts = [];
    if (activeRow === "saga" && parentChip) {
      parts.push('<button type="button" class="filter-path__crumb" data-path-go="' + esc(parentChip.getAttribute("data-handle")) + '">' + esc(parentChip.getAttribute("data-label")) + "</button>");
      parts.push('<span class="filter-path__sep" aria-hidden="true">›</span>');
    }
    if (active) parts.push('<span class="filter-path__crumb is-current">' + esc(active.getAttribute("data-label") || active.textContent) + "</span>");
    if (fmt) {
      if (active) parts.push('<span class="filter-path__sep" aria-hidden="true">+</span>');
      parts.push('<button type="button" class="filter-path__crumb filter-path__crumb--fmt is-current" data-path-clear-fmt title="Quitar este formato">' + esc(fmt.getAttribute("data-label")) + "</button>");
    }
    if (qCrumb) parts.push('<span class="filter-path__sep" aria-hidden="true">·</span>' + qCrumb);
    box.innerHTML = lead + parts.join("") +
      '<button type="button" class="filter-path__reset" data-path-reset aria-label="Quitar filtros">✕ Ver todo</button>';
    box.classList.add("has-filter");
  }

  function initSteps(root) {
    var list = (root || document).querySelectorAll("[data-catalog]");
    for (var i = 0; i < list.length; i++) syncSteps(list[i], false);
    initComingSoonSlots(root);
  }
  initSteps();
  document.addEventListener("shopify:section:load", function (ev) { initSteps(ev.target); });

  function applyChip(chip) {
    var p = catalogParts(chip);
    var c = p.catalog;
    var activeSmart = c.querySelector("[data-nf-view].is-active");
    var activeSmartView = activeSmart ? activeSmart.getAttribute("data-nf-view") : "";
    if (!activeSmartView) syncSmartView(p.catalog, "");
    var row = chip.getAttribute("data-row") || "tipo";
    var wasActive = chip.classList.contains("is-active");
    if (row === "tipo") {
      clearRow(c, "tipo");
      if (wasActive && chip.getAttribute("data-handle")) {
        var allChip = allFormatsChip(c);
        if (allChip) setActive(allChip, true);
      } else {
        setActive(chip, true);
      }
    } else if (row === "editorial") {
      clearRow(c, "saga");
      clearRow(c, "editorial");
      if (!wasActive) setActive(chip, true);
    } else {
      clearRow(c, "saga");
      clearRow(c, "editorial");
      if (wasActive) {
        var parentChip = c.querySelector('[data-chip][data-row="editorial"][data-handle="' + (chip.getAttribute("data-parent") || "") + '"]');
        if (parentChip) setActive(parentChip, true);
      } else {
        setActive(chip, true);
      }
    }
    syncSteps(c, true);
    if (activeSmartView && activeSmartView.indexOf("month-") === 0) applySmartView(p, activeSmartView, p.sort ? p.sort.value : "catalog-order");
    else showSelection(p, p.sort ? p.sort.value : "");
    if (row === "editorial" && !wasActive) {
      var filterPanel = c.querySelector("#filters");
      var sagaRow = c.querySelector("[data-saga-row]");
      if (filterPanel && sagaRow) {
        setTimeout(function () {
          filterPanel.scrollTo({ top: Math.max(0, sagaRow.offsetTop - 12), behavior: "smooth" });
        }, 80);
      }
    }
    if (row === "saga" && !wasActive && p.grid) {
      var top = p.grid.getBoundingClientRect().top;
      if (top > window.innerHeight * 0.75) p.grid.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  document.addEventListener("click", function (ev) {
    if (!ev.target.closest) return;
    var smart = ev.target.closest("[data-catalog] [data-nf-view]");
    if (smart) {
      ev.preventDefault();
      var ps = catalogParts(smart);
      clearRow(ps.catalog, "tipo");
      syncSteps(ps.catalog, false);
      applySmartView(ps, smart.getAttribute("data-nf-view"), ps.sort ? ps.sort.value : "catalog-order");
      return;
    }
    var chip = ev.target.closest("[data-catalog] [data-chip]");
    if (chip) {
      ev.preventDefault();
      applyChip(chip);
      return;
    }
    var go = ev.target.closest("[data-catalog] [data-path-go]");
    if (go) {
      var pg = catalogParts(go);
      clearRow(pg.catalog, "saga");
      clearRow(pg.catalog, "editorial");
      var target = pg.catalog.querySelector('[data-chip][data-row="editorial"][data-handle="' + go.getAttribute("data-path-go") + '"]');
      if (target) setActive(target, true);
      syncSteps(pg.catalog, true);
      showSelection(pg, pg.sort ? pg.sort.value : "");
      return;
    }
    var clearFmt = ev.target.closest("[data-catalog] [data-path-clear-fmt]");
    if (clearFmt) {
      var pf = catalogParts(clearFmt);
      clearRow(pf.catalog, "tipo");
      syncSteps(pf.catalog, true);
      showSelection(pf, pf.sort ? pf.sort.value : "");
      return;
    }
    var reset = ev.target.closest("[data-catalog] [data-path-reset]");
    if (reset) {
      var pr = catalogParts(reset);
      if (pr.search) { pr.search.value = ""; syncSearchUi(pr); }
      clearRow(pr.catalog, "tipo");
      clearRow(pr.catalog, "saga");
      clearRow(pr.catalog, "editorial");
      syncSteps(pr.catalog, true);
      showSelection(pr, pr.sort ? pr.sort.value : "");
      return;
    }
    var more = ev.target.closest("[data-catalog] #loadMore");
    if (more) {
      ev.preventDefault();
      var pm = catalogParts(more);
      var size = parseInt(pm.catalog.getAttribute("data-page-size"), 10) || 12;
      if (catalogState && catalogState.sorted && (catalogState.key === selection(pm).key || catalogState.key.indexOf("view:") === 0)) {
        var before = Math.min(catalogState.shown, catalogState.sorted.length);
        catalogState.shown += size;
        renderCatalog(pm, before);
      } else {
        showSelection(pm, pm.sort ? pm.sort.value : "", visibleCards(pm) + size);
      }
    }
  });

  /* ---------- buscador del catálogo ---------- */
  var searchTimer = null;

  function syncSearchUi(p) {
    if (!p || !p.search) return;
    var wrap = p.search.closest(".catalog-search");
    if (wrap) wrap.classList.toggle("has-value", !!p.search.value);
  }

  function runSearch(p) {
    if (!p || !p.grid) return;
    syncSearchUi(p);
    var query = currentQuery(p);
    if (catalogState && catalogState.all && (catalogState.key === selection(p).key || catalogState.key.indexOf("view:") === 0)) {
      var pageSize = parseInt(p.catalog.getAttribute("data-page-size"), 10) || 12;
      catalogState.query = query;
      catalogState.sorted = filterByQuery(catalogState.all, query);
      catalogState.shown = pageSize;
      renderCatalog(p);
    } else {
      showSelection(p, p.sort ? p.sort.value : "");
    }
    syncSteps(p.catalog, false);
  }

  document.addEventListener("input", function (ev) {
    var box = ev.target;
    if (!box || !box.matches || !box.matches("[data-catalog-search]")) return;
    var p = catalogParts(box);
    syncSearchUi(p);
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { runSearch(p); }, 160);
  });

  document.addEventListener("keydown", function (ev) {
    var t = ev.target;
    if (t && t.matches && t.matches("[data-catalog-search]")) {
      if (ev.key === "Enter") { ev.preventDefault(); clearTimeout(searchTimer); runSearch(catalogParts(t)); t.blur(); }
      if (ev.key === "Escape" && t.value) { t.value = ""; runSearch(catalogParts(t)); }
      return;
    }
    if (ev.key === "/" && !ev.ctrlKey && !ev.metaKey && !ev.altKey) {
      var tag = t && t.tagName ? t.tagName.toLowerCase() : "";
      if (tag === "input" || tag === "textarea" || tag === "select" || (t && t.isContentEditable)) return;
      var box = document.querySelector("[data-catalog-search]");
      if (box) { ev.preventDefault(); box.focus(); box.scrollIntoView({ behavior: "smooth", block: "center" }); }
    }
  });

  document.addEventListener("click", function (ev) {
    if (!ev.target.closest) return;
    var clear = ev.target.closest("[data-catalog] [data-search-clear]");
    if (!clear) return;
    ev.preventDefault();
    var p = catalogParts(clear);
    if (!p.search) return;
    p.search.value = "";
    runSearch(p);
    p.search.focus();
  });

  /* La búsqueda de la cabecera usa el mismo buscador del catálogo. */
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches("form.search")) return;
    var input = form.querySelector('input[name="q"]');
    var term = input ? input.value.trim() : "";
    var box = document.querySelector("[data-catalog-search]");
    ev.preventDefault();
    if (box) {
      box.value = term;
      runSearch(catalogParts(box));
      var cat = box.closest("[data-catalog]");
      if (cat) cat.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = "/collections/all?q=" + encodeURIComponent(term) + "#catalogo";
    }
  });

  (function initSearchFromUrl() {
    var box = document.querySelector("[data-catalog-search]");
    if (!box) return;
    var q = "";
    try { q = new URLSearchParams(window.location.search).get("q") || ""; } catch (e) {}
    if (!q) return;
    box.value = q;
    var header = document.getElementById("q-header");
    if (header) header.value = q;
    runSearch(catalogParts(box));
  })();

  document.addEventListener("change", function (ev) {
    var sel = ev.target;
    if (!sel || sel.id !== "orden" || !sel.closest("[data-catalog]")) return;
    var p = catalogParts(sel);
    var keep = catalogState && (catalogState.key === selection(p).key || catalogState.key.indexOf("view:") === 0) ? catalogState.shown : visibleCards(p);
    if (catalogState && catalogState.view) applySmartView(p, catalogState.view, sel.value, keep);
    else showSelection(p, sel.value, keep);
  });

  /* Ordena también la primera carga del catálogo. */
  function initializeCatalogOrder() {
    var initialCatalog = catalogParts();
    if (initialCatalog) {
      var view = "";
      try { view = new URLSearchParams(window.location.search).get("nf_view") || ""; } catch (e) {}
      if (view) applySmartView(initialCatalog, view, initialCatalog.sort ? initialCatalog.sort.value : "catalog-order", visibleCards(initialCatalog));
      else showSelection(initialCatalog, initialCatalog.sort ? initialCatalog.sort.value : "catalog-order", visibleCards(initialCatalog));
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initializeCatalogOrder);
  else initializeCatalogOrder();
})();


/* Midnight homepage carousel */
(function () {
  function setupMidnightHero(root) {
    if (!root || root.dataset.midnightReady === 'true') return;
    var slides = root.querySelectorAll('[data-midnight-slide]');
    var dots = root.querySelectorAll('[data-midnight-dot]');
    if (!slides.length) return;
    var current = 0;
    function show(index) {
      current = (index + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        var active = i === current;
        slides[i].classList.toggle('is-active', active);
        slides[i].setAttribute('aria-hidden', active ? 'false' : 'true');
        if (dots[i]) dots[i].classList.toggle('is-active', active);
      }
    }
    var prev = root.querySelector('[data-midnight-prev]');
    var next = root.querySelector('[data-midnight-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    for (var j = 0; j < dots.length; j++) {
      dots[j].addEventListener('click', function () {
        show(parseInt(this.getAttribute('data-midnight-dot'), 10));
      });
    }
    var timer = null;
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    function startAuto() {
      stopAuto();
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show(current + 1); }, 7000);
    }
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', startAuto);
    startAuto();
    root.dataset.midnightReady = 'true';
  }
  function initMidnightHeroes() {
    var roots = document.querySelectorAll('.nf-midnight-hero');
    for (var i = 0; i < roots.length; i++) setupMidnightHero(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMidnightHeroes);
  else initMidnightHeroes();
  document.addEventListener('shopify:section:load', initMidnightHeroes);
})();


/* Nightframe: panel de filtros móvil */
(function () {
  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest ? ev.target.closest("[data-filter-toggle]") : null;
    if (!btn) return;
    var catalog = btn.closest("[data-catalog]");
    var filters = catalog ? catalog.querySelector("#filters") : null;
    if (!filters) return;
    var open = filters.classList.toggle("is-open");
    btn.classList.toggle("is-open", open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    var mark = btn.querySelector(".catalog-filter-toggle__mark");
    if (mark) mark.textContent = open ? "−" : "+";
  });
})();


/* Nightframe: cierre accesible del panel móvil de filtros */
(function () {
  function closeCatalogFilters(catalog) {
    if (!catalog) return;
    var filters = catalog.querySelector('#filters');
    var toggle = catalog.querySelector('[data-filter-toggle]');
    if (filters) filters.classList.remove('is-open');
    if (toggle) {
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      var mark = toggle.querySelector('.catalog-filter-toggle__mark');
      if (mark) mark.textContent = '+';
    }
    document.body.classList.remove('nf-filter-panel-open');
  }
  document.addEventListener('click', function (ev) {
    var toggle = ev.target.closest ? ev.target.closest('[data-filter-toggle]') : null;
    if (toggle) {
      var catalog = toggle.closest('[data-catalog]');
      var filters = catalog ? catalog.querySelector('#filters') : null;
      setTimeout(function () { document.body.classList.toggle('nf-filter-panel-open', !!filters && filters.classList.contains('is-open')); }, 0);
      return;
    }
    var close = ev.target.closest ? ev.target.closest('[data-filter-close]') : null;
    if (close) closeCatalogFilters(close.closest('[data-catalog]'));
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var open = document.querySelector('[data-catalog] #filters.is-open');
    if (open) closeCatalogFilters(open.closest('[data-catalog]'));
  });
})();
